import { render, staticRenderFns } from "./hosts.vue?vue&type=template&id=49999d4a&scoped=true&"
import script from "./hosts.vue?vue&type=script&lang=js&"
export * from "./hosts.vue?vue&type=script&lang=js&"
import style0 from "./hosts.vue?vue&type=style&index=0&id=49999d4a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49999d4a",
  null
  
)

export default component.exports